import React from 'react';
import FaqAccordion from './FaqAccordion';

const FaqItem = ({ faq, faqItemRefs, isForceOpen }) => {
  return (
    <div
      ref={(el) => (faqItemRefs.current[faq.id] = el)}
      className='flex flex-col items-start py-[1px] border-b border-b-grayscale-gray03'
    >
      <FaqAccordion
        question={faq.question}
        answer={faq.answer}
        isForceOpen={isForceOpen}
      />
    </div>
  );
};

export default FaqItem;
